// extracted by mini-css-extract-plugin
export default {"donateSection":"DonateSection_donateSection__cyZB1"};